import axios from "axios";

const BASE_URL = process.env.REACT_APP_BASE_URL;

/**
 * Backend-driven access check.
 * Expected response (recommended):
 * {
 *   allowed: boolean,
 *   reason?: string,
 *   // optional extras:
 *   // chapterCompletionPercents?: number[]
 * }
 */
export const fetchCourseAccess = async ({ courseId, userId, token }) => {
  if (!courseId || !userId) {
    return { allowed: false, reason: "missing_identifiers" };
  }

  const url = `${BASE_URL}/access/course/${courseId}/user/${userId}`;

  const headers = {
    Accept: "application/json, text/plain, */*",
  };

  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  const response = await axios.get(url, { headers });
  return response.data;
};
